export default __webpack_public_path__ + "static/media/close_arrow_fiord_icon.e937e88c.svg";